module.exports = __webpack_public_path__ + "static/media/envelope-edit.34e081cd.svg";